
import Model from '../models/model';

export const model = new Model({
	name: 'Command',
	title: 'CommandHistory',
	defaultSort: 'CreatedOn ASC',
	disableAdd: true,
	disableDelete: true,
	idProperty: '_id',
	isAddRemove: false,
	disableExport: false,
	customeErrorOnSubmit: true,
	showGridRefreshBtn: true,
	width: 170,
	apiParams: ({ searchParams }) => ({ ClientCommandId: searchParams.get('clientCommandId') }),
	columns: [
		{ field: 'CommandName', header: 'Command', width: 170 },
		{ field: 'CreatedOn', type: 'dateTime', width: 170, isLocal: true },
		{ field: 'Username', header: "CreatedBy", width: 170 },
		{ field: 'ConfigSetting', width: 200 },
		{ field: 'Comment', width: 200 },
		{ field: 'SerialNumber', width: 200 }
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A4'
		}
	}
});

export default model.createFormBase();
